import Import from '@/services/import'

const fetch = async (context) => {
  return new Promise((resolve, reject) => {
    Import.templates().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const findTemplate = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Import.findTemplate(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetch,
  findTemplate
}



// WEBPACK FOOTER //
// ./src/features/import_templates/store/actions.js